import EventNoteIcon from "@mui/icons-material/EventNote";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PetsIcon from "@mui/icons-material/Pets";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import { ReactComponent as AppointmentsIcon } from "../../assets/images/svg/calendar.svg";
import { ReactComponent as HeartIcon } from "../../assets/images/svg/heart.svg";
import { ReactComponent as HomeIcon } from "../../assets/images/svg/home.svg";
import { ReactComponent as InventoryIcon } from "../../assets/images/svg/inventory-management.svg";
import { ReactComponent as PaymentIcon } from "../../assets/images/svg/invoice.svg";
import { ReactComponent as PetIcon } from "../../assets/images/svg/pet.svg";
import { ReactComponent as VetIcon } from "../../assets/images/svg/stethescope.svg";

const navAdminConfig = [
  { title: "dashboard", path: "/home", icon: <HomeOutlinedIcon /> },
  { title: "clinics", path: "/clinic", icon: <LocalHospitalIcon /> },
  { title: "pets", path: "/pet", icon: <PetsIcon /> },
  { title: "payments", path: "/payment", icon: <ReceiptLongIcon /> },
  { title: "Knowledge Base", path: "/knowledge-base", icon: <MenuBookIcon /> },
];

const navClinicConfig = [
  { title: "Dashboard", path: "/dashboard", icon: <HomeIcon /> },
  { title: "Vets", path: "/vets", icon: <VetIcon /> },
  { title: "Pets", path: "/pets", icon: <PetIcon /> },
  { title: "Appointments", path: "/appointments", icon: <AppointmentsIcon /> },
  { title: "Billing", path: "/payments", icon: <PaymentIcon /> },
  { title: "Inventory", path: "/inventory", icon: <InventoryIcon /> },
  // { title: "Reports", path: "/reports", icon: <PaymentIcon /> },
  // { title: "Coming soon", path: "/coming-soon", icon: <DeliveryIcon /> },
  { title: "Plan", path: "/plan", icon: <HeartIcon /> },
  { title: "Knowledge Base", path: "/knowledge-base", icon: <MenuBookIcon /> },
];

const navVetConfig = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <HomeIcon />,
  },
  {
    title: "Pets",
    path: "/pets",
    icon: <PetIcon />,
  },
  {
    title: "Appointments",
    path: "/appointments",
    icon: <AppointmentsIcon />,
  },
  {
    title: "Inventory",
    path: "/inventory",
    icon: <InventoryIcon />,
  },
  // {
  //   title: "Coming soon",
  //   path: "/coming-soon",
  //   icon: <DeliveryIcon />,
  // },
  {
    title: "Plan",
    path: "/plan",
    icon: <HeartIcon />,
  },
  {
    title: "Knowledge Base",
    path: "/knowledge-base",
    icon: <MenuBookIcon />,
  },
  // {
  //   title: "Coming soon",
  //   path: "/coming-soon2",
  //   icon: <DialIcon />,
  // },
  // {
  //   title: "Coming soon",
  //   path: "/coming-soon3",
  //   icon: <SettingsIcon />,
  // },
  // {
  //   title: "Coming soon",
  //   path: "/coming-soon4",
  //   icon: <CircleinfoIcon />,
  // },
];

const navBillingConfig = [
  // { title: "Dashboard", path: "/dashboard", icon: <HomeIcon /> },
  // { title: "Pets", path: "/pets", icon: <PetIcon /> },
  { title: "Billing", path: "/payments", icon: <PaymentIcon /> },
  { title: "Appointments", path: "/appointments", icon: <AppointmentsIcon /> },
  { title: "Inventory", path: "/inventory", icon: <InventoryIcon /> },
];

const navManagementConfig = [
  { title: "dashboard", path: "/home", icon: <HomeOutlinedIcon /> },
  { title: "vets", path: "/vets", icon: <LocalHospitalIcon /> },
  { title: "pets", path: "/pets", icon: <PetsIcon /> },
  { title: "appointments", path: "/appointments", icon: <EventNoteIcon /> },
  { title: "payments", path: "/payments", icon: <ReceiptLongIcon /> },
  {
    title: "pharma delivery",
    path: "/pharma-delivery",
    icon: <LocalShippingIcon />,
  },
  { title: "settings", path: "/settings", icon: <RoomPreferencesIcon /> },
  { title: "inventory", path: "/inventory", icon: <MedicalServicesIcon /> },
];

const navFrontDeskConfig = [
  { title: "Dashboard", path: "/dashboard", icon: <HomeIcon /> },
  { title: "Vets", path: "/vets", icon: <VetIcon /> },
  { title: "Pets", path: "/pets", icon: <PetIcon /> },
  { title: "Appointments", path: "/appointments", icon: <AppointmentsIcon /> },
];
const navPharmacyConfig = [
  // { title: "Dashboard", path: "/dashboard", icon: <HomeIcon /> },
  // { title: "Pets", path: "/pets", icon: <PetIcon /> },
  {
    title: "Pharmacy",
    path: "/phramacydashboard",
    icon: <PaymentIcon />,
  },
  // { title: "Inventory", path: "/inventory", icon: <InventoryIcon /> },
];
const navVeterinaryConfig = [
  { title: "dashboard", path: "/dashboard", icon: <HomeOutlinedIcon /> },
];
const navInventoryConfig = [
  { title: "Inventory", path: "/inventory", icon: <InventoryIcon /> },
];
const navGroomerConfig = [
  { title: "GroomDashboard", path: "/groomdashboard", icon: <InventoryIcon /> },
];
const navLabConfig = [
  { title: "Diagnostics", path: "/labdashboard", icon: <InventoryIcon /> },
];

const getNavConfigForRole = (userRole) => {
  if (userRole === "ROLE_ADMIN") return navAdminConfig;
  if (userRole === "ROLE_CLINIC" || userRole === "ROLE_CLINICADMIN") {
    return navClinicConfig;
  }
  if (userRole === "ROLE_INVENTORY") return navInventoryConfig;
  if (userRole === "ROLE_BILLING") return navBillingConfig;
  if (userRole === "ROLE_RECEPTION") return navFrontDeskConfig;
  if (userRole === "ROLE_GROOMER") return navGroomerConfig;
  if (userRole === "ROLE_RADIOLOGY") return navLabConfig;
  if (userRole === "ROLE_PHARMACY") return navPharmacyConfig;
  return navVetConfig;
};

const getNavConfigForRoles = (roles = []) => {
  const navByPath = new Map();

  roles.forEach((userRole) => {
    getNavConfigForRole(userRole).forEach((nav) => {
      if (!navByPath.has(nav.path)) {
        navByPath.set(nav.path, nav);
      }
    });
  });

  if (navByPath.size === 0) return navVetConfig;

  const ordered = [];
  const orderedPaths = new Set();

  navClinicConfig.forEach((nav) => {
    if (navByPath.has(nav.path)) {
      ordered.push(navByPath.get(nav.path));
      orderedPaths.add(nav.path);
    }
  });

  roles.forEach((userRole) => {
    getNavConfigForRole(userRole).forEach((nav) => {
      if (!orderedPaths.has(nav.path)) {
        ordered.push(nav);
        orderedPaths.add(nav.path);
      }
    });
  });

  return ordered;
};

export {
  getNavConfigForRole,
  getNavConfigForRoles,
  navAdminConfig,
  navBillingConfig,
  navClinicConfig,
  navFrontDeskConfig,
  navGroomerConfig,
  navInventoryConfig,
  navLabConfig,
  navManagementConfig,
  navPharmacyConfig,
  navVetConfig,
  navVeterinaryConfig,
};
